import styled from "styled-components";
import { Button, CircularProgress } from "@material-ui/core";
import { VscFilePdf } from "react-icons/vsc";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  overflow: auto;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 60%;
  padding: 0 20px;
  text-align: center;
`;

export const FileName = styled.strong`
  font-size: 26px;
  word-break: break-all;

  @media (max-width: 1228px) {
    font-size: 22px;
  }
`;

export const FileSize = styled.p`
  font-size: 22px;
`;

export const Actions = styled.div`
  margin-top: 38px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  @media (max-width: 1228px) {
    margin-top: 28px;
  }
`;

export const CancelAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:hover {
    filter: brightness(1.1);
  }
`;

export const SendAction = styled(CancelAction)``;

export const ActionTitle = styled.p`
  font-size: 22px;
  font-weight: bold;
  color: ${(props) => props.color};
`;

export const BorderedButton = styled(Button).attrs({
  variant: "outlined",
  component: "label",
})`
  height: 80px;
  width: 80px;
  border-radius: 50%;
  border-width: 3px;
  border-color: ${(props) => props.color};

  svg {
    color: ${(props) => props.color};
    font-size: 45px;
  }

  @media (max-width: 1228px) {
    height: 72px;
    width: 72px;
  }
`;

export const FileButton = styled.label`
  background: #5f65cf;
  height: 46px;
  width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  border-radius: 50%;
  cursor: pointer;

  transition: filter 0.5s;

  &:hover {
    filter: brightness(1.1);
  }
`;

export const PDFIcon = styled(VscFilePdf).attrs({
  size: 22,
})`
  color: #ffffff;
`;

export const Loading = styled(CircularProgress).attrs({
  size: 43,
})``;
